// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__35Dna","select":"styles_select__3y8cJ"};